module.exports = __webpack_public_path__ + "media/images/expert__kay-voser-11438d72a016ab201b511b19d125262a.png";